"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _saas = require("./services/saas");

Object.keys(_saas).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _saas[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _saas[key];
    }
  });
});

var _saas2 = require("./constants/saas");

Object.keys(_saas2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _saas2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _saas2[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/@weike/services/lib/index.js
// module id = 334
// module chunks = 6